const o = {
  request_splice:
    "function request_splice(address tovault, uint fid, uint mid, string memory encoded) public",
};

export default o;
